// RB-MY01-PalmGarden.web/src/components/PlantForm/components/SectionCard.tsx
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

// Define the fadeIn animation
const fadeIn = {
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(10px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)'
    }
  },
  animation: 'fadeIn 0.3s ease-out'
};

interface SectionCardProps {
  title: string;
  icon?: React.ReactNode;
  theme?: { color: string };
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ 
  title, 
  icon, 
  theme, 
  children 
}) => (
  <Paper 
    elevation={0} 
    sx={{ 
      mb: 4,
      border: '1px solid',
      borderColor: theme?.color || 'divider',
      borderRadius: 2,
      overflow: 'hidden'
    }}
  >
    <Box sx={{ 
      p: 2, 
      display: 'flex', 
      alignItems: 'center',
      backgroundColor: (theme?.color || 'primary.main') + '10', // 10% opacity
      borderBottom: '1px solid',
      borderColor: theme?.color || 'divider'
    }}>
      {icon}
      <Typography variant="subtitle1" fontWeight={600} color={theme?.color || 'primary.main'}>
        {title}
      </Typography>
    </Box>
    <Box sx={{ p: 3, ...fadeIn }}>
      {children}
    </Box>
  </Paper>
);

export default React.memo(SectionCard);
